import { HubspotBrochureDownload } from ".";
import Lazyload from "react-lazy-load";
import Menubar from "../MenubarAd";
import "../../styles/demo-req-page.css";
import WellnessTracker from "./WellnessTracker";
import VideoCarousel from "./VideoCarousel";
import { Trans, useTranslation, language } from "gatsby-plugin-react-i18next";


const EmployeeWellnessV1 = () => {
    const wistiaVideoUrls = [
        "https://www.youtube.com/embed/LSX4pxSB6Qw",
        "https://www.youtube.com/embed/L_39IykL-O4",
    ];
    const items = [
        {
            title: "Activity Tracking",
            description: {
                __html: `Monitor your daily activities, and track your progress.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1700626252/VantageFit/2023/Holistic-wellness-tracker-Record_Each_Action_Every_Progress.webp",
        },
        {
            title: "Nutrition & Hydration",
            description: {
                __html: `Stay on top of your nutrition and hydration with real-time logs, reminders and insights.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1700626252/VantageFit/2023/Holistic-wellness-tracker-Nourish_Hydrate_Repeat.webp",
        },
        {
            title: "Fitness & Exercise",
            description: {
                __html: `<p class="section-para font-weight-normal"><span class="font-weight-bold">7 Minute Workout</span>: Guiding your way to a healthier you, 7 minutes at a time.<br><br> <span class="font-weight-bold">Squat Tracker</span>: Sculpt, squat, and track your way to fitness with precision with AI.</p>`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1700626255/VantageFit/2023/Holistic-wellness-tracker-Bringing_Fitness_To_Your_Fingertips..webp",
        },
        {
            title: "Health Metrics",
            description: {
                __html: `Stay informed with real-time health metrics.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1700626251/VantageFit/2023/Holistic-wellness-tracker-Insights_to_Shape_Your_Wellness_Journey.webp",
        },
        {
            title: "Mental Well-being",
            description: {
                __html: `Prioritize mental health with guided mindfulness sessions and mood journals.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1700626255/VantageFit/2023/Holistic-wellness-tracker-Find_Your_Zen_Achieve_Balance.webp",
        },
    ];
    return (
        <>
            <Menubar
                home={"#home"}
                solutions={"#solutions"}
                features={"#features"}
                connectivity={"#connectivity"}
                successstories={"#successstories"}
                bookDemo={"#bookDemo"}
            />
            <section className="homepage hero-bg position-relative section-pdn-hero pt-8">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg">
                    <div className="col-12 col-md-7">
                        <div className="col-12 pl-0 pr-0">
                            <h1 className="font-weight-semibold hero-heading pt-0 no-br">
                                Prioritize Employee <br />
                                Wellness
                            </h1>
                            <p className="hero-para font-weight-semibold no-br">
                                Cheer up and motivate your employees with our
                                Virtual Corporate <br /> Wellness Contests and
                                Curated Health Content.
                            </p>
                            <div className="pl-0 pr-0 col-12 mtb25 d-md-flex justify-content-md-center d-lg-flex justify-content-lg-start align-items-center">
                                <a
                                    href="#bookDemo"
                                    className="vfitcompanycta mr-3 arrowbtn-img"
                                >
                                    Book a Demo
                                </a>
                                <a
                                    className="ghost-btn-white ghost-btn-red"
                                    href="#video"
                                >
                                    Watch Video
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 ">
                        <div className="hero-right-img">
                            <img
                                class="img-responsive"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1711626872/VantageFit/2023/hero-hompage.png"
                                alt="image 1"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section
                id="solutions"
                name="solutions"
                className="position-relative section-pdn dark-bg1"
            >
                <div className="container custom_container pt-5">
                    <h2 className="section-heading text-center mb-5 text-white">
                        A happier and healthier workforce,{" "}
                        <span className="green-font">holistically</span>
                    </h2>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div className="soln-card">
                                <div className="content-overlay"></div>
                                <img
                                    className="img-responsive mb-4"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/e_trim/v1704969895/VantageFit/2023/landing-page/Step.webp"
                                    alt="Step challenge"
                                    width="393"
                                    height="451"
                                />
                                <div className="soln-card-content">
                                    <h3>Step Challenge</h3>
                                    <p>
                                        Promote physical activity and boost
                                        employee engagement with step-tracking
                                        challenges.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="soln-card">
                                <div className="content-overlay"></div>
                                <img
                                    className="img-responsive mb-4"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/e_trim/v1704969894/VantageFit/2023/landing-page/Multiactivity.webp"
                                    alt="Multiactivity challenge"
                                    width="393"
                                    height="451"
                                />
                                <div className="soln-card-content">
                                    <h3>Multi-activity Challenge</h3>
                                    <p>
                                        Empower Employees with a Variety of
                                        Fitness Tasks Tailored to Individual
                                        Preferences.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="soln-card">
                                <div className="content-overlay"></div>
                                <img
                                    className="img-responsive"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/e_trim/v1704969896/VantageFit/2023/landing-page/Team.webp"
                                    alt="Team challenge"
                                    width="393"
                                    height="451"
                                />
                                <div className="soln-card-content">
                                    <h3>Team Challenge</h3>
                                    <p>
                                        Foster Teamwork, Collaboration, and
                                        Healthy Competition with Group Fitness
                                        Activities.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="bookDemo" name="bookDemo" className="w-100">
                <div className="row">
                    <div className="col-md-6 col-sm-12 demo-page-bg">
                        <div className="container">
                            <div className="padding-dem">
                                <div className="pt-5 pb-3">
                                    <h2 className="font-weight-semibold py-2 section-heading text-white">
                                        Schedule a <br /> Vantage Fit Demo
                                    </h2>
                                </div>
                                <div>
                                    <p
                                        className="section-para font-weight-normal aos-init aos-animate text-white text-center text-lg-left"
                                        data-aos="fade-right"
                                        data-aos-once="true"
                                    >
                                        Explore a new era of team health with
                                        our corporate wellness platform,
                                        tailored to enhance employee well-being!
                                    </p>
                                </div>
                                <div className="demo-pageform">
                                    <Lazyload>
                                        <HubspotBrochureDownload formID="e23ab1ed-02c7-42c1-90bc-ecd78ae786c3" />
                                    </Lazyload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        id="video"
                        className="col-md-6 col-sm-12 demo-page-bg2 dm-align-center padd-y-5"
                    >
                        <div className="container">
                            <div
                                className="w-100 d-flex justify-content-center"
                                style={{ height: "fit-content" }}
                            >
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    width="100%"
                                    height="auto"
                                    style={{
                                        borderRadius: "10px",
                                        maxWidth: "600px",
                                        border: "2px white solid",
                                    }}
                                >
                                    <source
                                        type="video/webm"
                                        src="https://res.cloudinary.com/vantagecircle/video/upload/v1703741378/VantageFit/2023/Vantage_Fit_Video_for_Website.webm"
                                    />
                                </video>
                            </div>
                        </div>
                        <div
                            className="container"
                            style={{ maxWidth: "600px", marginTop: "2rem" }}
                        >
                            <p
                                className="text-white text-center"
                                style={{ fontSize: "1.3rem" }}
                            >
                                Trusted by{" "}
                                <span className="orange-font font-weight-bold">
                                    700+{" "}
                                </span>
                                organizations, including Fortune 500
                            </p>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/First-source-logo.webp"
                                            alt="firstSource"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/MI-logo.webp"
                                            alt="MI"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2 border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/accenture-logo.webp"
                                            alt="accenture"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/ESAF-logo.webp"
                                            alt="ESAF"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/citi-logo.webp"
                                            alt="citi"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2 border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/Bajaj-logo.webp"
                                            alt="Bajaj"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container custom_container position-relative col-12 text-center sect-white-col-2">
                <div className="row justify-content-center align-items-center">
                    <div className="col-10 pr-lg-0">
                        <div className="row">
                            <div className="col-12 font-weight-bold activity-icon pr-lg-0">
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-12 col-md-2">
                                        <img
                                            className="mb-2 mb-lg-4"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1700626249/VantageFit/2023/activity-icon.svg"
                                            alt="Activity"
                                            width="54"
                                            height="77"
                                        />
                                        <p className="font-weight-bold mb-lg-0">
                                            Activity
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-1">
                                        <p> + </p>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <img
                                            className="mb-2 mb-lg-4"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1700626252/VantageFit/2023/Nutrition-icon.svg"
                                            alt="Nutrition"
                                            width="67"
                                            height="77"
                                        />
                                        <p className="font-weight-bold mb-lg-0">
                                            Nutrition
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-1">
                                        {" "}
                                        <p> + </p>{" "}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <img
                                            className="mb-2 mb-lg-4"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1700626249/VantageFit/2023/exercise-icon.svg"
                                            alt="Exercise"
                                            width="56"
                                            height="77"
                                        />
                                        <p className="font-weight-bold mb-lg-0">
                                            Exercise
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-1">
                                        {" "}
                                        <p> + </p>{" "}
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <img
                                            className="mb-2 mb-lg-4"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1700626251/VantageFit/2023/mindfulness-icon.svg"
                                            alt="Mindfulness"
                                            width="103"
                                            height="77"
                                        />
                                        <p className="font-weight-bold mb-lg-0">
                                            Mindfulness
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-1">
                                        {" "}
                                        <p> = </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2 pl-lg-0">
                        <div className="activity-icon">
                            <img
                                className="mb-2 mb-lg-4"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1700626253/VantageFit/2023/total-wellbeing-icon.svg"
                                alt="Total Wellbeing"
                                width="77"
                                height="77"
                            />
                            <p className="font-weight-bold mb-lg-0">
                                Total Wellbeing
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section
                className="home-bg-1 section-pdn"
                id="features"
                name="features"
            >
                <div className="section-heading text-center text-light">
                    {" "}
                    Pave the Way to{" "}
                    <span style={{ color: "#41D8B4" }}>Wellness</span>
                </div>
                <WellnessTracker wellnessItems={items} />
            </section>
            <section className="relative pb-0">
                <div className="worldmap-img">
                    <div className="container section-pdn">
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-12 col-md-6">
                                <h2 className="section-heading mb-5">
                                    Impact of{" "}
                                    <span className="red-font">
                                        Vantage Fit
                                    </span>{" "}
                                    on clients across the globe.
                                </h2>
                            </div>
                            <div className="col-12 col-md-6 clientstat">
                                <div className="col-12 p0">
                                    <div className="row">
                                        <div className="col-6 col-md-6">
                                            <div className="fact-stats">
                                                <img
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1704870039/VantageFit/2023/calories-1.svg"
                                                    alt="calories burned"
                                                    width="45"
                                                    height="64"
                                                />
                                                <p className="statno orange-font">
                                                    1.2B+
                                                </p>
                                                <p>Calories burned</p>
                                            </div>
                                            <div className="fact-stats">
                                                <img
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1704870039/VantageFit/2023/globe-1.svg"
                                                    alt="Around the globe"
                                                    width="64"
                                                    height="64"
                                                />
                                                <p className="statno green-font">
                                                    345x
                                                </p>
                                                <p>Around the globe</p>
                                            </div>
                                        </div>
                                        <div className="col-6 col-md-6">
                                            <div className="fact-stats">
                                                <img
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1704870039/VantageFit/2023/step-1.svg"
                                                    alt="Steps taken"
                                                    width="45"
                                                    height="64"
                                                />
                                                <p className="statno red-font">
                                                    19.4B
                                                </p>
                                                <p>Steps taken</p>
                                            </div>
                                            <div className="fact-stats">
                                                <img
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1704870038/VantageFit/2023/burger-1.svg"
                                                    alt="Big mac burnt"
                                                    width="84"
                                                    height="64"
                                                />
                                                <p className="statno orange-font">
                                                    21M
                                                </p>
                                                <p>Big mac burnt</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="connectivity" className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                            <div className="col-12 col-md-7 col-lg-6 sync-fast">
                                <div className="col-12 sync-fast">
                                    <h2 className="py-2 section-heading green-text">
                                        Connect <span>Fast</span>. <br />
                                        Sync <span>Fast</span>.
                                    </h2>
                                    <p className="section-para font-weight-normal">
                                        Seamless integration with all platforms
                                        and wearables to constantly monitor your
                                        wellbeing.
                                    </p>
                                    <div className="col-12 d-flex justify-content-center align-items-center pt-2 flex-wrap flex-m-nowrap px-0">
                                        <div className="row justify-content-center justify-content-md-start">
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Bitmap.webp"
                                                    alt="Apple Watch"
                                                    width="96"
                                                    height="21"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_3.webp"
                                                    alt="Fitbit"
                                                    width="95"
                                                    height="30"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_2.webp"
                                                    alt="Garmin"
                                                    width="102"
                                                    height="35"
                                                />
                                            </div>
                                            {/* <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_4.webp"
                                                    alt="Sony"
                                                    width="89"
                                                    height="16"
                                                />
                                            </div> */}
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Bitmap_5.webp"
                                                    alt="Google Fit"
                                                    width="114"
                                                    height="23"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Group_24.webp"
                                                    alt="Apple Health"
                                                    width="127"
                                                    height="19"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="d-flex justify-content-center align-items-center flex-wrap flex-md-nowrap">

                                    </div> */}
                                </div>
                            </div>
                            <div className="col-12 col-md-5 cta-img">
                                <div className="d-flex justify-content-center">
                                    <img
                                        className="img-responsive"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1701166425/VantageFit/2023/Vfit-Integration-Apps_Devices.webp"
                                        decoding="async"
                                        loading="lazy"
                                        alt="Connect What You Prefer"
                                        width="500"
                                        height="617"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                id="successstories"
                className="position-relative z1 testi-wrap pt-5"
            >
                <div className="container custom_container px-6">
                    <div className="testi-video-wrapper">
                                        <div className="row col-12 d-flex justify-content-between align-items-center p0">
                                            <div className="col-12 col-md-4 h-full p0">
                                                <h2 className="py-2 section-heading no-br">
                                                    <Trans>Real people, <br/>Real results</Trans>
                                                </h2>
                                                <p className="section-para">
                                                    <Trans>Vantage Fit speaks for itself, but
                                                    our customer reviews speak even
                                                    louder.</Trans>
                                                </p>
                                            </div>
                                            <div className="col-12 col-md-8 px-0">
                                                <div className="">
                                                    <Lazyload offset={300}>
                                                        <VideoCarousel videoUrls={wistiaVideoUrls}/>
                                                    </Lazyload>
                                                </div>
                                            </div>
                                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-5">
                <div className="container custom_container p0 recog-logos">
                    <h2 className="col-12 text-center f-500">
                        Globally recognized by
                    </h2>
                    <div className="d-flex justify-content-center align-items-center m-d-block py-5">
                        <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                            <img
                                decoding="async"
                                loading="lazy"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Leader_Enterprise_Gobal.webp"
                                alt="G2 award4"
                                width="113"
                                height="146"
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                            <img
                                decoding="async"
                                loading="lazy"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Brandon_Hall_Group.webp"
                                alt="Brandon hall award"
                                width="201"
                                height="146"
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                            <img
                                decoding="async"
                                loading="lazy"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Bakers-Dozen.webp"
                                alt="Baker's Dozen award"
                                width="146"
                                height="146"
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                            <img
                                decoding="async"
                                loading="lazy"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592947/VantageFit/2023/best-of-relationship-winter-2023-gradient.webp"
                                alt="relationship winter 2023"
                                width="126"
                                height="146"
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                            <img
                                decoding="async"
                                className=""
                                loading="lazy"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592947/VantageFit/2023/crozdesk-happiest-users-badge.webp"
                                alt="crozdesk-happiest-users-badge"
                                width="146"
                                height="146"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EmployeeWellnessV1;
